import { AfterViewInit, Component, computed, ElementRef, HostListener, input, OnInit, signal } from '@angular/core';
import { MiniChartsBase } from '../min-charts';

@Component({
  selector: 'chart-circle',
  standalone: false,
  templateUrl: './circle.component.html',
  styleUrls: ['./circle.component.scss']
})
export class CircleComponent extends MiniChartsBase implements OnInit, AfterViewInit {
  isViewInit = signal<boolean>(false);
  override value = computed(() => this.isViewInit() ? this.toFixed(this.valueProvided()) : 0);

  // Export mode - when true, disables auto-resize and uses fixed dimensions
  export = input<boolean>(false);

  // Signal to track container width for responsive sizing
  private containerWidth = signal<number>(0);

  constructor(private elementRef: ElementRef) {
    super();
  }

  ngOnInit(): void {
    // Skip container width calculation in export mode
    if (!this.export()) {
      this.updateContainerWidth();
    }
  }

  ngAfterViewInit(): void {
    // In export mode, set immediately without animation delay
    console.log('this.export()', this.export());

    if (this.export()) {
      this.isViewInit.set(true);
    } else {
      setTimeout(() => {
        this.isViewInit.set(true);
      }, 300);
    }
  }

  @HostListener('window:resize')
  onResize(): void {
    if (!this.export()) {
      this.updateContainerWidth();
    }
  }

  private updateContainerWidth(): void {
    const container = this.elementRef.nativeElement;
    if (container && container.parentElement) {
      const parentWidth = container.parentElement.clientWidth;
      if (parentWidth > 0) {
        this.containerWidth.set(parentWidth);
      }
    }
  }

  // Override width to use container width when not in export mode
  // Max width is the original width input in rem * 16 (base rem to px)
  get responsiveWidth(): number {
    if (this.export() || this.containerWidth() === 0) {
      return this.width();
    }
    const maxWidth = this.widthInRem() * 16;
    return Math.min(this.containerWidth(), maxWidth);
  }

  get responsiveHeight(): number {
    if (this.export() || this.containerWidth() === 0) {
      return this.height();
    }
    const ratio = this.heightInRem() / this.widthInRem();
    return this.responsiveWidth * ratio;
  }

  get radius() {
    return Math.floor((this.responsiveWidth / 2) - (this.size() / 2)) - .5
  }
}